import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import returnitemtostockaction from "../../context/action/item/returnitemtostockaction";
const Deleteditem = () => {
    const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);
  return (
    <div className="min-h-screen bg-slate-50 p-6 md:p-8">
      {/* Page Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">کاڵای سڕاوە</h1>
          <p className="text-sm text-slate-400 mt-0.5">بەڕێوەبردنی کاڵا سڕاوەکان</p>
        </div>
      </div>

      {/* Expense List Card */}
      <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
        
        {/* Section Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
          <h2 className="text-base font-semibold text-slate-800">لیستی کاڵای سڕاوە</h2>
        </div>
        {/* Table */}
        <table className="w-full">
          <thead>
            <tr className="bg-slate-50 border-b border-slate-100">
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                ناوی کاڵا
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                باڕکۆد
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                نرخ
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                بڕی ماوە
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                کاتیگۆری کاڵا
              </th>
              <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
              گەڕانەوە بۆ مەخزەن
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-50">
              {initState.removeditem.map((lis)=>(
                  <tr
                  key={lis.item_id}
                  className="hover:bg-slate-50 transition-colors duration-100"
                >
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      {lis.item_name}
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      {lis.item_barcode}
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      {numberbeautify(lis.item_price)}
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      {lis.item_qty}
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                      {lis.category_name}
                  </td>
                  <td
                    className="px-6 py-4 text-sm font-medium text-slate-800 text-right"
                    onClick={() => {
                      if (
                          window.confirm(
                            "ئاگاداری گێڕانەوەی کاڵا بۆ مەخزەن . دڵنیای ؟"
                          ) == true
                        ) {
                        returnitemtostockaction(lis.item_id)(recaller)(setrecaller)(initDispatch)(clear)
                      }
                    }}
                  >
                    <span
                      className={
                        "relative inline-block px-3 py-1 font-semibold text-green-900 leading-tight cursor-pointer"
                      }
                    >
                      <span
                        aria-hidden
                        className={
                          "absolute inset-0 bg-green-400 opacity-50 rounded-md"
                        }
                      ></span>
                      <span className="relative">گێڕانەوە</span>
                    </span>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Deleteditem